<template>
  <div>
    <v-app>
      <div class="md-layout">
        <div class="md-layout-item md-size-100 mx-auto">
          <v-form @submit.prevent="submitBasicProperty">
            <v-text-field v-model="basicPropertyForm.structId" label="场景编码 *" :rules="[v => !!v || '场景编码不能为空']"
              hint="请使用英文/字符,首字母不要使用字符，不能重复"></v-text-field>
            <v-text-field v-model="basicPropertyForm.name" label="场景名称 *" :rules="[v => !!v || '场景名称不能为空']">
            </v-text-field>
            <v-text-field v-model="basicPropertyForm.tag" label="场景标签 *" :rules="[v => !!v || '场景标签不能为空']">
            </v-text-field>
            <v-text-field v-model="basicPropertyForm.info" label="场景信息 *" :rules="[v => !!v || '场景信息不能为空']">
            </v-text-field>
            <v-row justify="space-between">
              <v-col cols="10" md="10">
                <v-select v-model="basicPropertyForm.deviceTypeId" :items="typeListData" item-text="name"
                  item-value="id" label="场景类型 *" :rules="[v => !!v || '场景类型不能为空']">
                  <template v-slot:append-item>
                    <v-list-item class="v-list-item--link" ripple @mousedown.prevent value="self_def"
                      @click.native="showBaseExtDialog = true">
                      <v-list-item-content>
                        <v-list-item-title>
                          自定义
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="2" md="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon large color="green darken-2" @click.native="showEdit" v-bind="attrs" v-on="on"
                      style='font-size: 26px;margin-top: 20px;'>mdi-message-text</v-icon>
                  </template>
                  <span>场景详细信息</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </div>
    </v-app>
    <DeviceDetailDialog :showDialog.sync="showBaseExtDialog" @handleConfirm="handleConfirm" @handleCancel="handleCancel"
      :sceneId="sceneId" :typeData="typeMap[basicPropertyForm.deviceTypeId]" />
  </div>
</template>

<script>
import { findTypeList, saveDefine } from '@/api/device'
import DeviceDetailDialog from './DeviceDetailDialog.vue'

export default {
  components: {
    DeviceDetailDialog
  },
  props: {
    formData: {
      type: Object,
      default: () => { }
    },
    sceneId: {
      type: String,
      default: ''
    }
  },
  inject: ['topNode'],
  watch: {
    'formData.name'() {
      this.basicPropertyForm = this.formData
    },
    sceneId(val) {
      this.getTypeList()
    }
  },
  data() {
    return {
      basicPropertyForm: {},
      showBaseExtDialog: false,
      typeListData: [],
      typeMap: {}
    }
  },
  methods: {
    getTypeList() {
      findTypeList({
        sceneId: this.sceneId,
        type: 'scene'
      }).then((res) => {
        this.typeListData = res.data
        this.typeMap = res.data.reduce((pre, next) => {
          pre[next.id] = next
          return pre
        }, {})
      })
    },
    changeType(item, type) {
      this.$emit('changeType')
    },
    handleConfirm({ form, isUpdate }) {
      if (isUpdate) {
        const index = this.typeListData.findIndex((item) => item.id === form._id)
        this.typeListData[index] = form
      } else {
        this.getTypeList()
        form.id = form._id
        this.typeListData.push(form)
        this.basicPropertyForm.deviceTypeId = form._id
        this.$forceUpdate()
      }
      this.showBaseExtDialog = false
    },
    handleCancel() {
      this.showBaseExtDialog = false
      if (this.basicPropertyForm.deviceTypeId === '') {
        this.basicPropertyForm.deviceTypeId = 'self_def'
      }
    },
    showEdit() {
      this.showBaseExtDialog = true
    },
    // 编写保存
    submitBasicProperty() {
      const treeNodeMap = this.topNode.treeDatas.reduce((pre, next) => {
        pre[next.id] = next;
        return pre;
      }, {});

      const getAliasName = (treeNodeId, treeNodeMap, nodeNameArr = []) => {
        const node = treeNodeMap[treeNodeId];
        nodeNameArr.push(node ? node.name : "");
        if (node.level === 1) {
          return nodeNameArr.reverse().join("/");
        }
        if (!treeNodeId || !treeNodeMap) {
          return "";
        }
        return getAliasName(node.pid, treeNodeMap, nodeNameArr);
      };
      this.basicPropertyForm.fullPath = getAliasName(this.basicPropertyForm.structId, treeNodeMap)

      this.basicPropertyForm.type = 'scene'
      saveDefine(this.basicPropertyForm).then((res) => {
        if (res.data._id) {
          this.basicPropertyForm = res.data
        }
        this.$emit('hanldeSave', this.basicPropertyForm)
        this.$notify({
          timeout: 1500,
          message: '操作成功！',
          icon: 'add_alert',
          horizontalAlign: 'center',
          verticalAlign: 'bottom',
          type: 'success'
        })
      })
    }
  }
}
</script>

<style>

</style>
